export class Level {

   id: string;
   nameLong: string;
   public constructor(init?: Partial<Level>) {
      Object.assign(this, init);
   }
}